import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';

import { ProgramsVM } from '../../view-model/programs.viewModel.types';

import * as styles from './ProgramsNoResults.css';

type ProgramsNoResultsProps = {
  dispatch: ProgramsVM['dispatch'];
};

export const ProgramsNoResults = ({ dispatch }: ProgramsNoResultsProps) => {
  const onClear = () => {
    dispatch('Search', '');
    dispatch('SetFilter', {
      status: 'all',
      soldAs: 'all',
    });
  };

  return (
    <div className={styles.container} data-testid="programs-no-results">
      <Typography variant="body" size="large" fontWeight="medium">
        No programs match these filters.
      </Typography>
      <Button variant="outlined" onClick={onClear}>
        Clear filters
      </Button>
    </div>
  );
};
